import { ClassType } from '../../../shared/types/class-types.enum';
import { LiveClassDto } from '../../../shared/types/LiveClassDto';

function sortByClassBegin(liveClasses: Array<LiveClassDto>) {
  return liveClasses.sort((a, b) => a.classBegin - b.classBegin);
}

function getUniqueBySubtype(liveClasses: Array<LiveClassDto>) {
  return liveClasses.reduce<LiveClassDto[]>((acc, liveClass) => {
    if (!acc.find((l) => l.subType === liveClass.subType)) {
      acc.push(liveClass);
    }
    return acc;
  }, []);
}

function findFirstWithNoLiveClassStatus(liveClasses: Array<LiveClassDto>) {
  return liveClasses.find((liveClass) => !liveClass.liveClassStatus);
}

export function getClassBeginFromFirstsWithNoLiveClassStatus(liveClasses: Array<LiveClassDto>) {
  const firstLiveClassWithNoLiveClassStatus = findFirstWithNoLiveClassStatus(liveClasses);

  if (firstLiveClassWithNoLiveClassStatus) {
    return firstLiveClassWithNoLiveClassStatus.classBegin;
  } else {
    // Get the oldest classes' classBegin
    return liveClasses[0].classBegin;
  }
}

export const removeHybridClasses = (liveClasses: Array<LiveClassDto>): Array<LiveClassDto> =>
  liveClasses.filter((liveClass) => liveClass.classType !== ClassType.HYBRID);

export function getUniqueOrderedLiveClassesBySubtype(liveClasses: Array<LiveClassDto>): Array<LiveClassDto> {
  const liveClassesSortedByClassBegin = sortByClassBegin(liveClasses);
  const liveClassesWithUniqueSubTypes = getUniqueBySubtype(liveClassesSortedByClassBegin);

  return liveClassesWithUniqueSubTypes
    .sort((a, b) => a.order - b.order)
    .sort((a, b) => Number(b.signupEnabled) - Number(a.signupEnabled))
    .sort((a, b) => Number(b.signedUp) - Number(a.signedUp));
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-section/services/live-class-array-utils.ts